import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../../shop/store';
import { combineLatest, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchResultsGuard {
  private store = inject(Store);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return combineLatest([
      this.store.select(fromStore.getSearchLoaded),
      this.store.select(fromStore.getSearchLoading),
      this.store.select(fromStore.getSearchQuery),
    ]).pipe(
      tap(([loaded, loading, loadedQuery]) => {
        const q = route.queryParams['q'];
        //console.log('loadedQuery', loadedQuery, 'new', q);

        if ((q !== loadedQuery && !loading) || !loaded) {
          this.store.dispatch(fromStore.LoadSearchResults({ searchQuery: q }));
        }
      }),
      map(([loaded, loading, loadedQuery]) => loaded && route.queryParams['q'] === loadedQuery),
      filter(loaded => loaded),
      take(1)
    );
  }
}
